import React, { useEffect, useState } from "react";
import { useLocation, NavLink } from "react-router-dom";
import { FaHome, FaBriefcase, FaStar, FaExchangeAlt } from "react-icons/fa";
import "./BottomNavbar.css";

const BottomNavbar = () => {
  const [userRole, setUserRole] = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const location = useLocation();

  // Function to load user role
  const loadUserRole = () => {
    const role = sessionStorage.getItem("userRole");
    const loggedIn = localStorage.getItem("isLoggedIn") === "true";
    
    setUserRole(role);
    setIsLoggedIn(loggedIn);
  };

  // Initial load
  useEffect(() => {
    loadUserRole();

    // Event listener for role switch
    const handleRoleSwitch = () => {
      loadUserRole();  // Reload the role when switched
    };

    window.addEventListener("roleSwitch", handleRoleSwitch);

    return () => {
      window.removeEventListener("roleSwitch", handleRoleSwitch);
    };
  }, []);

  if (userRole === null) {
    return null;  // Loading state
  }

  return (
    <div className="bottom-navbar">
      <NavLink 
        to="/home" 
        className={({ isActive }) => isActive ? "nav-item active" : "nav-item"}
      >
        <FaHome />
        <span>Home</span>
      </NavLink>

      {userRole === "Contractor" ? (
        <NavLink 
          to="/subscriptions" 
          className={({ isActive }) => isActive ? "nav-item active" : "nav-item"}
        >
          <FaStar />
          <span>Subscriptions</span>
        </NavLink>
      ) : (
        <NavLink 
          to="/labour-subscription" 
          className={({ isActive }) => isActive ? "nav-item active" : "nav-item"}
        >
          <FaStar />
          <span>Subscriptions</span>
        </NavLink>
      )}

      {userRole === "Labour" ? (
        <NavLink 
          to="/browse-jobs" 
          className={({ isActive }) => isActive ? "nav-item active" : "nav-item"}
        >
          <FaBriefcase />
          <span>Jobs</span>
        </NavLink>
      ) : (
        <NavLink 
          to="/post-job" 
          className={({ isActive }) => isActive ? "nav-item active" : "nav-item"}
        >
          <FaBriefcase />
          <span>Jobs</span>
        </NavLink>
      )}
      <NavLink 
        to="/" 
        className={({ isActive }) => isActive ? "nav-item active" : "nav-item"}
      >
        <FaExchangeAlt />
        <span>Switch Role</span>
      </NavLink>
    </div>
  );
};

export default BottomNavbar;
